import React, { useContext, useEffect, useState, useRef, createRef } from 'react'
import { 
    Container,
    LineDiv,
    ContentDiv,
    MainText,
    FilterDiv,
    BoldedFilterText,
    NormalFilterText,
    CloseImg,
    DeleteDiv,
    DeleteImg,
    DeleteText
 } from './style'
import TableFiltersContext from '../../../contexts/TableFiltersContext'
import cross from '../../../assets/stock/FiltersHeader/cross.svg'
import trash from '../../../assets/stock/FiltersHeader/trash.svg'
import SectionContext from '../../../contexts/SectionContext'

interface SymbolTable{
    [key: string]: string
}

interface Filter {
    field: string;
    type: string;
    text: string;
}

const FiltersHeader: React.FC = () => {
    const { 
        stockFilters, 
        setStockFilters, 
        movementFilters, 
        setMovementFilters,
        routerStatusFilter,
        setRouterStatusFilter,
        freightStatusFilter,
        setFreightStatusFilter,
        globalFilter,
        setGlobalFilter,
        movementTypeFilter,
        setMovementTypeFilter
    } = useContext(TableFiltersContext);

    const { stockSection, routerSection } = useContext(SectionContext);

    const symbolTable: SymbolTable = {
        "Começa com": "começa com",
        "Contém": "contém",
        "Não contém": "não contém",
        "Acaba com": "acaba com",
        "É igual a": "=",
        "É diferente de": "≠",
        "É maior que": "maior que",
        "É menor que": "menor que",
        "É maior/igual que": "maior ou igual que",
        "É menor/igual que": "menor ou igual que"
    }

    const deleteGenericFilter = (index: number) => {
        if (stockSection === 'stock') {
            const newFilters = [...stockFilters];
            newFilters.splice(index, 1);
            setStockFilters(newFilters);
        } else if (stockSection === 'movement') {
            const newFilters = [...movementFilters];
            newFilters.splice(index, 1);
            setMovementFilters(newFilters);
        }
    };

    const clearRouterStatusFilter = () => {
        setRouterStatusFilter('');
    };

    const clearFreightStatusFilter = () => {
        setFreightStatusFilter('');
    };

    const clearGlobalFilter = () => {
        setGlobalFilter('');
    };

    const clearMovementTypeFilter = () => {
        setMovementTypeFilter('Pedido');
    };

    const renderFilters = () => {
        const filtersToDisplay: { field: string; text: string; onDelete: () => void }[] = [];

        if (stockSection === 'stock' && stockFilters.length > 0) {
            stockFilters.forEach((filter, index) => {
                filtersToDisplay.push({
                    field: filter.field,
                    text: `${symbolTable[filter.type as keyof SymbolTable]} ${filter.text}`,
                    onDelete: () => deleteGenericFilter(index)
                });
            });
        } else if (stockSection === 'movement' && movementFilters.length > 0) {
            movementFilters.forEach((filter, index) => {
                filtersToDisplay.push({
                    field: filter.field,
                    text: `${symbolTable[filter.type as keyof SymbolTable]} ${filter.text}`,
                    onDelete: () => deleteGenericFilter(index)
                });
            });
        }

        if (globalFilter) {
            filtersToDisplay.push({
                field: 'Busca Global',
                text: `contém "${globalFilter}"`,
                onDelete: clearGlobalFilter
            });
        }

        if (movementTypeFilter && movementTypeFilter !== 'Pedido') {
            filtersToDisplay.push({
                field: 'Tipo de Movimento',
                text: `é igual a "${movementTypeFilter}"`,
                onDelete: clearMovementTypeFilter
            });
        }

        if (routerSection === 'router' && routerStatusFilter && routerStatusFilter !== 'Todos') {
            filtersToDisplay.push({
                field: 'Status do Roteiro: ',
                text: ` "${routerStatusFilter}"`,
                onDelete: clearRouterStatusFilter
            });
        }

        if (routerSection === 'freight' && freightStatusFilter && freightStatusFilter !== 'Todos') {
            filtersToDisplay.push({
                field: 'Status do Frete:',
                text: ` "${freightStatusFilter}"`,
                onDelete: clearFreightStatusFilter
            });
        }

        if (filtersToDisplay.length === 0) {
            return null;
        }

        return (
            <ContentDiv>
                <MainText>Filtros:</MainText>
                {filtersToDisplay.map((filter, index) => (
                    <FilterDiv key={index}>
                        <BoldedFilterText>{filter.field}</BoldedFilterText>
                        <NormalFilterText>{filter.text}</NormalFilterText>
                        <CloseImg src={cross} alt='Close tab icon' onClick={filter.onDelete} />
                    </FilterDiv>
                ))}
                {filtersToDisplay.length > 0 && (
                    <DeleteDiv onClick={() => {
                        setStockFilters([]);
                        setMovementFilters([]);
                        setGlobalFilter('');
                        setMovementTypeFilter('Pedido');
                        setRouterStatusFilter('');
                        setFreightStatusFilter('');
                    }}>
                        <DeleteImg src={trash} alt='Trash icon' />
                        <DeleteText>Limpar Tudo</DeleteText>
                    </DeleteDiv>
                )}
            </ContentDiv>
        );
    };

    return (
        <Container>
            <LineDiv />
            {renderFilters()}
        </Container>
    );
};

export default FiltersHeader;